<div [@matErrorAnimation]="forbiddenName" class="mat-form-field-subscript-wrapper">
    <mat-error>{{ forbiddenName }}</mat-error>
</div>
